import { getPetriOverrides, toObject } from '../DefaultPanel/utils/petri';
export function withExperimentOverrides(experiments) {
    if (experiments === void 0) { experiments = {}; }
    return Object.assign(experiments, toObject(getPetriOverrides()));
}
//# sourceMappingURL=withExperimentOverrides.js.map